export const UsersPermissions = {
  USERS_CREATE: 'USERS_CREATE',
  USERS_MODIFY: 'USERS_MODIFY',
  USERS_READ: 'USERS_READ',
} as const;
export type UsersPermissions = (typeof UsersPermissions)[keyof typeof UsersPermissions];

export const GroupsPermissions = {
  ROLES_CREATE: 'ROLES_CREATE',
  ROLES_MODIFY: 'ROLES_MODIFY',
  ROLES_READ: 'ROLES_READ',
} as const;
export type GroupsPermissions = (typeof GroupsPermissions)[keyof typeof GroupsPermissions];

export const HierarchiesPermissions = {
  HIERARCHIES_CREATE: 'HIERARCHIES_CREATE',
  HIERARCHIES_MODIFY: 'HIERARCHIES_MODIFY',
  HIERARCHIES_READ: 'HIERARCHIES_READ',
} as const;
export type HierarchiesPermissions = (typeof HierarchiesPermissions)[keyof typeof HierarchiesPermissions];

export const OccupationsPermissions = {
  OCCUPATION_CREATE: 'OCCUPATION_CREATE',
  OCCUPATION_MODIFY: 'OCCUPATION_MODIFY',
  OCCUPATION_READ: 'OCCUPATION_READ',
} as const;
export type OccupationsPermissions = (typeof OccupationsPermissions)[keyof typeof OccupationsPermissions];

export const TrainingManagementPermissions = {
  TRAINING_MANAGEMENT_CREATE: 'TRAINING_MANAGEMENT_CREATE',
  TRAINING_MANAGEMENT_MODIFY: 'TRAINING_MANAGEMENT_MODIFY',
  TRAINING_MANAGEMENT_READ: 'TRAINING_MANAGEMENT_READ',
  TRAINING_MANAGEMENT_DELETE: 'TRAINING_MANAGEMENT_DELETE',
} as const;
export type TrainingManagementPermissions =
  (typeof TrainingManagementPermissions)[keyof typeof TrainingManagementPermissions];

export const FormsPermissions = {
  BASIC_FORMBUILDER_DELETE_FIELDS: 'BASIC_FORMBUILDER_DELETE_FIELDS',
  BASIC_FORMBUILDER_READ: 'BASIC_FORMBUILDER_READ',
  BASIC_FORMBUILDER_CREATE: 'BASIC_FORMBUILDER_CREATE',
  BASIC_FORMBUILDER_MODIFY: 'BASIC_FORMBUILDER_MODIFY',
  ADVANCED_FORMBUILDER_READ: 'ADVANCED_FORMBUILDER_READ',
  ADVANCED_FORMBUILDER_CREATE: 'ADVANCED_FORMBUILDER_CREATE',
  ADVANCED_FORMBUILDER_MODIFY: 'ADVANCED_FORMBUILDER_MODIFY',
  ADVANCED_FORMBUILDER_DELETE: 'ADVANCED_FORMBUILDER_DELETE',
} as const;
export type FormsPermissions = (typeof FormsPermissions)[keyof typeof FormsPermissions];

export const AdminHomePagePermissions = {
  HOME_PAGE_CREATE: 'HOME_PAGE_CREATE',
  HOME_PAGE_MODIFY: 'HOME_PAGE_MODIFY',
  HOME_PAGE_READ: 'HOME_PAGE_READ',
} as const;
export type AdminHomePagePermissions = (typeof AdminHomePagePermissions)[keyof typeof AdminHomePagePermissions];

export const LicensingPermissions = {
  LICENSING_READ: 'LICENSING_READ',
} as const;
export type LicensingPermissions = (typeof LicensingPermissions)[keyof typeof LicensingPermissions];

export const SchedulePagePermissions = {
  SCHEDULES_CREATE: 'SCHEDULES_CREATE',
  SCHEDULES_MODIFY: 'SCHEDULES_MODIFY',
  SCHEDULES_READ: 'SCHEDULES_READ',
} as const;
export type SchedulePagePermissions = (typeof SchedulePagePermissions)[keyof typeof SchedulePagePermissions];

export const RulesPermissions = {
  AUTO_RULE: 'AUTO_RULE',
} as const;
export type RulesPermissions = (typeof RulesPermissions)[keyof typeof RulesPermissions];

export const RecordNotificationsPermissions = {
  NOTIFICATIONS_CREATE: 'NOTIFICATIONS_CREATE',
  NOTIFICATIONS_MODIFY: 'NOTIFICATIONS_MODIFY',
  NOTIFICATIONS_READ: 'NOTIFICATIONS_READ',
} as const;
export type RecordNotificationsPermissions =
  (typeof RecordNotificationsPermissions)[keyof typeof RecordNotificationsPermissions];

export const RiskMatrixPermissions = {
  RISK_MATRIX_MODIFY: 'RISK_MATRIX_MODIFY',
  RISK_MATRIX_READ: 'RISK_MATRIX_READ',
} as const;
export type RiskMatrixPermissions = (typeof RiskMatrixPermissions)[keyof typeof RiskMatrixPermissions];

export const ModulesPermissions = {
  MODULES_CREATE: 'MODULES_CREATE',
  MODULES_MODIFY: 'MODULES_MODIFY',
  MODULES_READ: 'MODULES_READ',
} as const;
export type ModulesPermissions = (typeof ModulesPermissions)[keyof typeof ModulesPermissions];
